var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PrincipalComponent',{key:_vm.value,attrs:{"value":_vm.value,"use-muted":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }